/**
 * Shared knobs for server-side picker / live-search dropdowns.
 *
 * `SEARCH_MIN_CHARS` must match the server `$orRegex(..., N)` floor.
 * `SEARCH_DEBOUNCE_MS` — wait before refetch after the term changes.
 *
 * Scroll-load page size comes from `user.defaultTableRows` (via
 * `useAuthStore` in `useScrollSearch`).
 *
 * Pagination: server search routes return `{ …items, total }`. Account
 * search maps `totalAccessibleAccountLength` → `total`. Derive scroll
 * continuation with `searchUtility.has(total, page, pageSize)`.
 */
export const SEARCH_DEBOUNCE_MS = 800

export const SEARCH_MIN_CHARS = 4

/** Default page size for scroll-search pickers when user preference is unavailable. */
export const SEARCH_PAGE_SIZE = 15
